// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hg9rct2 {
  height: 200px;
}
@media screen and (min-width: 768px) {
  .hg9rct0 {
    max-width: 700px;
  }
  .hg9rct1 {
    flex-basis: calc(40% - 8px);
  }
  .hg9rct2 {
    flex-basis: 60%;
    height: 402px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,aAAa;EACf;AACF","sourcesContent":[".hg9rct2 {\n  height: 200px;\n}\n@media screen and (min-width: 768px) {\n  .hg9rct0 {\n    max-width: 700px;\n  }\n  .hg9rct1 {\n    flex-basis: calc(40% - 8px);\n  }\n  .hg9rct2 {\n    flex-basis: 60%;\n    height: 402px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
